import { orderBy } from "lodash"
import Axios from "axios"
import { API_ADMIN } from "../../utils/constants/Api"
import { IFilterList, IFilterListWithoutPagination } from "../../utils/interfaces/FilterListInterface"
import { ApprovedPaymentModel } from "../models/ApprovedPaymentModel"
import { BilletCancelationModel } from "../models/BilletCancelationModel"
import { BillingDocumentCreationModel } from "../models/BillingDocumentCreationModel"
import { BillingCreationModel } from "../models/BillingCreationModel"
import { BillingEmailModel } from "../models/BillingEmailModel"
import { BillingModel } from "../models/BillingModel"
import { BillingTypeModel } from "../models/BillingTypeModel"
import { BillingUpdateInformationModel } from "../models/BillingUpdateInformationModel"
import { InvoiceCancelationModel } from "../models/InvoiceCancelationModel"
import { BilletHistoryModel } from "../models/BilletHistoryModel"
import { SubscriberModel } from "../../subscriber/models/SubscriberModel"

export default {
    getBillingList(page:number, filter: IFilterList):Promise<BillingModel[]> {
        return Axios.get(`${API_ADMIN}billings?page=${page}${filter.toPartialQueryString()}&limit=100`)
            .then(({data}) => {
                const billingList = (data || []).map((s:BillingModel) => new BillingModel(s))                
                return orderBy(billingList, ['subscriberProduct.subscriber.realName', 'dueDate'], ['asc', 'desc'])
            })
    },
    getBillingById(id:string):Promise<BillingModel> {
        return Axios.get(`${API_ADMIN}billings/${id}`)
            .then(({data}) => {
                return new BillingModel(data)
            })
    },
    getBillingTypeList():Promise<BillingTypeModel[]> {
        return Axios.get(`${API_ADMIN}billing_types`)
            .then(({data}) => {
                return (data || []).map((s:BillingTypeModel) => new BillingTypeModel(s))
            })
    },
    approvePayment(id:string, approvedPayment:ApprovedPaymentModel):Promise<any> {
        return Axios.post(`${API_ADMIN}billings/${id}/approve_payment`, approvedPayment)
            .then(({data}) => data)
    },
    createBillingDocuments(billetDates:BillingDocumentCreationModel):Promise<any> {
        return Axios.post(`${API_ADMIN}billings/billets/create`, billetDates)
            .then(({data}) => data)
    },
    createBillings(billingCreation:BillingCreationModel):Promise<any> {
        return Axios.post(`${API_ADMIN}billings`, billingCreation)
            .then(({data}) => data)
    },
    resendBillingEmail(billingId:string, billingEmail:BillingEmailModel):Promise<any> {
        return Axios.post(`${API_ADMIN}billings/${billingId}/billets/resend`, billingEmail)
            .then(({data}) => data)
    },
    updateInformation(billingId:string, billingUpdateInformation:BillingUpdateInformationModel):Promise<any> {
        return Axios.patch(`${API_ADMIN}billings/${billingId}/billets`, billingUpdateInformation)
            .then(({data}) => data)
    },
    deleteApprovedPayment(billingId:string):Promise<any> {
        return Axios.delete(`${API_ADMIN}billings/${billingId}/approved_payment`)
    },
    cancelOrDeleteBilling(billingId:string):Promise<BillingModel | undefined> {
        return Axios.delete(`${API_ADMIN}billings/${billingId}`)
            .then(({data}) => {
                if (!!data) {
                    return new BillingModel(data)
                }

                return undefined
            })
    },
    cancelBillet(billingId:string, billetCancelation:BilletCancelationModel):Promise<BillingModel> {
        return Axios.put(`${API_ADMIN}billings/${billingId}/billets/cancel`, billetCancelation)
            .then(({data}) => new BillingModel(data))
    },
    cancelInvoice(billingId:string, invoiceCancelation:InvoiceCancelationModel):Promise<any> {
        return Axios.put(`${API_ADMIN}billings/${billingId}/invoices/cancel`, invoiceCancelation)
            .then(({data}) => new BillingModel(data))
    },
    getBilletHistory(idBillet:string):Promise<BilletHistoryModel[]> {
        return Axios.get(`${API_ADMIN}billings/billets/${idBillet}/history`)
            .then(({data}) => {
                return (data || []).map((bh: BilletHistoryModel) => new BilletHistoryModel(bh))
            })
    },
}
